const urlParser = document.createElement('a')

export function domain(url) {
  urlParser.href = url
  return urlParser.hostname
}

export function count(arr) {
  return arr.length
}

export function prettyDate(date) {
  var a = new Date(date)
  return a.toDateString()
}

export function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }

  return time + label + 's'
}

export function parserQueries(url, query) {
  for (let pro in query) {
    if (query.hasOwnProperty(pro)) {
      url = url + pro + '=' + query[pro] + '&'
    }
  }
  url = url.substring(0, url.length - 1)
  return url;
}

export function thousandSeprator(value) {
  if (value !== '' && value !== undefined && value !== 0 && value !== '0' && value !== null) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return value;
  }
}

export function currency(number) {
  if (number !== '' && number !== undefined && number !== 0 && number !== '0' && number !== null) {
    return number.toLocaleString('sg-SG', {
      style: 'currency',
      currency: 'SGD',
      minimumFractionDigits: 0
    });
  } else {
    return number;
  }
}

export function abbr(num) {
  if (String(num).length < 4) {
    return num
  } else if (String(num).length >= 4) {
    return Math.floor(num / 1000) + 'K';
  } else {
    return Math.floor(num / 1000000) + 'M';
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js